import React from 'react';
import Header from '../components/Header';
import SEOHead from '../components/SEOHead';
import EmailAndPhoneButton from '../components/EmailAndPhoneButton';
import './styles/Cookies.css';

function Cookies() {
  return (
    <div className="cookies-side">
      <SEOHead
        title="Cookiepolitik - JBC Entreprenøren"
        description="Læs om hvordan JBC Entreprenøren bruger cookies på vores hjemmeside, og hvilke rettigheder du har."
        url="/cookies"
      />
      <Header />
      <EmailAndPhoneButton />

      <div className="cookies-hero">
        <h1>Cookiepolitik</h1>
        <p>Sidst opdateret: juni 2026</p>
      </div>

      <div className="cookies-indhold">
        <section className="cookies-sektion">
          <h2>Hvad er cookies?</h2>
          <p>
            Cookies er små tekstfiler, der gemmes på din computer, telefon eller tablet, når du besøger en hjemmeside.
            De hjælper hjemmesiden med at huske dine præferencer og forbedre din brugeroplevelse ved fremtidige besøg.
          </p>
        </section>

        <section className="cookies-sektion">
          <h2>Hvilke cookies bruger vi?</h2>
          <p>JBC Entreprenøren ApS benytter følgende typer cookies:</p>

          <div className="cookies-tabel-wrapper">
            <table className="cookies-tabel">
              <thead>
                <tr>
                  <th>Navn</th>
                  <th>Type</th>
                  <th>Formål</th>
                  <th>Levetid</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td><code>jbc-cookie-consent</code></td>
                  <td>Nødvendig</td>
                  <td>Gemmer din cookieaccept, så du ikke ser banneret ved hvert besøg</td>
                  <td>365 dage</td>
                </tr>
                <tr>
                  <td>Firebase / Google Analytics</td>
                  <td>Statistik</td>
                  <td>Anonymiseret statistik om sidevisninger og brugeradfærd</td>
                  <td>Op til 2 år</td>
                </tr>
              </tbody>
            </table>
          </div>
        </section>

        <section className="cookies-sektion">
          <h2>Nødvendige cookies</h2>
          <p>
            Nødvendige cookies er afgørende for hjemmesidens grundlæggende funktionalitet. Disse cookies kan ikke
            fravalges, da siden ikke fungerer korrekt uden dem. De indsamler ikke personoplysninger og bruges
            udelukkende til tekniske formål.
          </p>
        </section>

        <section className="cookies-sektion">
          <h2>Statistik-cookies</h2>
          <p>
            Vi bruger Google Analytics til at forstå, hvordan vores besøgende bruger hjemmesiden. Dataene er
            anonymiserede og bruges udelukkende til at forbedre indholdet og brugeroplevelsen på jbcentreprenoeren.dk.
            Du kan til enhver tid afvise statistik-cookies via vores cookiebanner.
          </p>
        </section>

        <section className="cookies-sektion">
          <h2>Dine rettigheder</h2>
          <p>Du har ret til at:</p>
          <ul>
            <li>Trække dit samtykke tilbage til enhver tid</li>
            <li>Anmode om indsigt i, hvilke oplysninger vi behandler om dig</li>
            <li>Anmode om sletning af dine oplysninger</li>
            <li>Klage til Datatilsynet, hvis du mener, vi ikke behandler dine data korrekt</li>
          </ul>
          <p>
            Du kan slette cookies i din browsers indstillinger. Vær opmærksom på, at dette kan påvirke
            funktionaliteten af hjemmesiden.
          </p>
        </section>

        <section className="cookies-sektion">
          <h2>Tredjepartscookies</h2>
          <p>
            Vi bruger tjenester fra Google (Firebase og Analytics), som kan sætte egne cookies. Disse tjenester
            er underlagt Googles privatlivspolitik. Vi har ingen kontrol over indholdet af tredjepartscookies.
          </p>
        </section>

        <section className="cookies-sektion">
          <h2>Ændringer i cookiepolitikken</h2>
          <p>
            Vi forbeholder os retten til at opdatere denne cookiepolitik. Eventuelle ændringer vil blive
            offentliggjort på denne side med en opdateret dato. Vi anbefaler, at du med jævne mellemrum
            gennemgår politikken.
          </p>
        </section>

        <section className="cookies-sektion">
          <h2>Kontakt</h2>
          <p>
            Har du spørgsmål til vores cookiepolitik eller behandling af personoplysninger, er du velkommen til
            at kontakte os:
          </p>
          <div className="cookies-kontakt-info">
            <p><strong>JBC Entreprenøren ApS</strong></p>
            <p>Undløse, Holbæk Kommune</p>
            <p>E-mail: <a href="mailto:info@jbcentreprenoeren.dk">info@jbcentreprenoeren.dk</a></p>
            <p>Telefon: <a href="tel:+4560908014">+45 60 90 80 14</a></p>
          </div>
        </section>
      </div>
    </div>
  );
}

export default Cookies;
